/**
 * @generated SignedSource<<9e907ed022135130ad6d7352483ebeaa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InteriorsLandingRoomsHeader_roomsHeadModule$data = {
  readonly imageUrl: string | null;
  readonly linkUrl: string | null;
  readonly title: string | null;
  readonly " $fragmentType": "InteriorsLandingRoomsHeader_roomsHeadModule";
};
export type InteriorsLandingRoomsHeader_roomsHeadModule$key = {
  readonly " $data"?: InteriorsLandingRoomsHeader_roomsHeadModule$data;
  readonly " $fragmentSpreads": FragmentRefs<"InteriorsLandingRoomsHeader_roomsHeadModule">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InteriorsLandingRoomsHeader_roomsHeadModule",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "linkUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "imageUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    }
  ],
  "type": "InteriorsLandingModuleItem",
  "abstractKey": null
};

(node as any).hash = "661aced90a370243f1fdd29d1b1a8104";

export default node;
